import "./Home.scss";
import { Link } from "react-router-dom";
import Logo from "../../assets/Logo.png";
import Module1 from "../../assets/module1.png";
import Module2 from "../../assets/module2.png";
import Module3 from "../../assets/module3.png";
import Module4 from "../../assets/module4.png";
import YoutubeEmbed from "../YoutubeEmbed/YoutubeEmbed";

const Home = () => {
  return (
    <div className="home">
      <div className="content">
        <h1>AI-Lit</h1>
        <h2>
          Learn More About Artificial Intelligence (AI) with Interactive AI-Lit
          Modules!
        </h2>
        <div className="mainLogo">
          <img src={Logo} alt="" />
        </div>
        <div className="modules">
          <Link to="/module1">
            <div className="module">
              <img src={Module1} alt="Module 1" />
              <span>Module 1</span>
            </div>
          </Link>
          <Link to="/module2">
            <div className="module">
              <img src={Module2} alt="Module 2" />
              <span>Module 2</span>
            </div>
          </Link>
          <Link to="/module3">
            <div className="module">
              <img src={Module3} alt="Module 3" />
              <span>Module 3</span>
            </div>
          </Link>
          <Link to="/module4">
            <div className="module">
              <img src={Module4} alt="Module 4" />
              <span>Module 4</span>
            </div>
          </Link>
        </div>
        <div className="mission">
          <h2>Our Mission</h2>
          <YoutubeEmbed embedId="F3tyi1Q48p4?si=Lc5vPWCVJob1wTkQ" />
        </div>
      </div>
    </div>
  );
};

export default Home;
